import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";

import Paper from "@material-ui/core/Paper";
import UseStyles from "./UseStyles";

const Owner = ({ ownerInfo }) => {
  const classes = UseStyles();

  return (
    <TableContainer component={Paper}>
      <Table  className={classes.table} aria-label="simple table">
        <TableBody>
          <TableRow className={classes.row_color1}>
            <TableCell style={{width:"20%"}} className={classes.cell_header_bold} align="left">
              Current Owner
            </TableCell>
            <TableCell>
              <span align="left">{ownerInfo.current_owner_name}</span>
            </TableCell>
          </TableRow>
          <TableRow className={classes.row_color2}>
            <TableCell className={classes.cell_header_bold} align="left">
              Previous Owner
            </TableCell>
            <TableCell align="left">{ownerInfo.previous_owner_name}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default Owner;
